import UIFlex, { copyFlex, IUIFlexProps } from './UIFlex';
import './UIContainer.scss';
import Flex from '../data/Flex';
import React, { useState } from 'react';

export interface IUIContainerProps extends IUIFlexProps{
    padding?:boolean;
    animateIntro?:boolean;
    animateIntroDelay?:number;
    canScroll?:boolean;
}

export default class UIContainer extends React.Component<IUIContainerProps>{

    flex:React.RefObject<UIFlex> = React.createRef();

    get divRef(){
        return this.flex.current?.div;
    }
    get div(){
        let htmlDiv:HTMLDivElement | undefined = undefined;
        if(this.flex.current?.div.current){
            htmlDiv = this.flex.current.div.current;
        }
        return htmlDiv;
    }
    render(){
        let cn:string = "container";
        if(this.props.className) cn+=" "+this.props.className;        
        if(this.props.padding) cn+=" padding";
        if(this.props.animateIntro) cn+=" animated";
        if(this.props.animateIntroDelay) cn+=" animatedDelay";
        
    
        let animationDelay:number=this.props.animateIntroDelay || 0;

        let canScroll:boolean=false;
        if(this.props.canScroll) canScroll=true;

        const flex = copyFlex({
            wrap:true,
            wrapRev:false,
            overflowScrollY:canScroll
            
        },this.props.flex);

        if(animationDelay>0){
            flex.style = {...flex.style, animationDelay:animationDelay+"s"}
        }

        return (
            <UIFlex onMouseOver={this.props.onMouseOver} onMouseOut={this.props.onMouseOut} ref={this.flex} className={cn} flex={flex}>
                {this.props.children}
            </UIFlex>
        );
    }
}


export interface IUIWhiteBoxProps extends IUIFlexProps{
    noPadding?:boolean;
    marginBottom?:boolean;
    animateIntro?:boolean;
    animateIntroDelay?:number;
}


export class UIWhiteBox extends React.Component<IUIWhiteBoxProps> {
    container:React.RefObject<UIContainer> = React.createRef();

    get div(){
        return this.container.current?.div;
    }
    get divRef(){
        return this.container.current?.divRef;
    }
    
    
    render() {

        let cn:string = "whiteBox";
        if(this.props.className){
            cn+=" "+this.props.className;
        }
        if(this.props.marginBottom){
            cn+=" marginBot";
        }
    

        let padding:boolean=true;
        if(this.props.noPadding){
            padding=false;
        }
        const flex = copyFlex({
            direction:Flex.COLUMN
        },this.props.flex);

        return (
            <UIContainer 
                onMouseOver={this.props.onMouseOver} 
                onMouseOut={this.props.onMouseOut}
                ref={this.container} 
                animateIntro={this.props.animateIntro} 
                animateIntroDelay={this.props.animateIntroDelay} 
                padding={padding} 
                className={cn} 
                flex={flex} 
                >
                {this.props.children}
            </UIContainer>
        );
    }
}
